module.exports = __webpack_public_path__ + "img/arauco.3356ab7a.png";